import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useGroup } from '../../context/GroupContext';
import OnboardingBottomNav from '../../components/common/OnboardingBottomNav';
import '../../styles/onboarding/Onboarding.css';

const ProfileCreation = () => {
  const navigate = useNavigate();
  const { groupId } = useParams();
  const [familyStatus, setFamilyStatus] = useState('');

  // Handle family status selection
  const handleStatusSelect = (status) => {
    console.log('Selected status:', status); // Debug log
    setFamilyStatus(status);
    
    // Also save to localStorage immediately to ensure it's stored
    localStorage.setItem('familyStatus', status);
  };

  // Handle back button
  const handleBack = () => {
    navigate(`/group/${groupId}/onboarding/identity`);
  };
  
  // Handle next button with conditional navigation
  const handleNext = () => {
    // Store the selected family status
    localStorage.setItem('familyStatus', familyStatus);
    
    if (familyStatus === 'married-kids' || familyStatus === 'married-no-kids') {
      // If married (with or without kids), go to anniversary page
      navigate(`/group/${groupId}/onboarding/anniversary`, {
        state: { familyStatus }
      });
    } else if (familyStatus === 'single' || familyStatus === 'other') {
      // If single or other, skip directly to Yartzheits page
      navigate(`/group/${groupId}/onboarding/yartzheits`);
    } else {
      // Fallback navigation in case of unexpected family status
      navigate(`/group/${groupId}/onboarding/identity`);
    }
  };

  // Family status options with their respective icons
  const familyOptions = [
    { id: 'single', title: 'Single', icon: '👤' },
    { id: 'married-kids', title: 'Married - with kids', icon: '👨‍👩‍👧‍👦' },
    { id: 'married-no-kids', title: 'Married - no kids', icon: '👫' },
    { id: 'other', title: 'Other', icon: '🫂' },
  ];

  // Check if a family status is selected
  const isFormValid = familyStatus !== '';

  // Progress dots renderer
  const renderProgressDots = () => {
    const totalSteps = 4;
    const currentStep = 2;
    const dots = [];
    
    for (let i = 0; i < totalSteps; i++) {
      dots.push(
        <div 
          key={i} 
          className={`progress-dot ${i + 1 <= currentStep ? 'active' : ''}`}
        ></div>
      );
    }
    
    return dots;
  };

  return (
    <div className="onboarding-container">
      <div className="onboarding-content">
        <h1 className="onboarding-title">Create your Profile</h1>
        
        <h2 className="family-status-question">
          Which of these best describes your Family?
        </h2>
        
        <p className="family-status-description">
          Help us celebrate your milestones! Share your important dates so your synagogue can honor them with you.
        </p>
        
        <div className="family-status-options">
          {familyOptions.map(option => (
            <div 
              key={option.id}
              className={`family-status-option ${familyStatus === option.id ? 'selected' : ''}`}
              onClick={() => handleStatusSelect(option.id)}
            >
              <div className="family-status-option-icon">{option.icon}</div>
              <div className="family-status-option-title">{option.title}</div>
            </div>
          ))}
        </div>
      </div>
      
      {/* Progress dots */}
      <div className="fixed-progress-dots">
        {renderProgressDots()}
      </div>
      
      {/* Bottom Navigation */}
      <OnboardingBottomNav 
        onBack={handleBack} 
        onNext={handleNext} 
        nextDisabled={!isFormValid} 
        nextLabel="Next"
      />
    </div>
  );
};

export default ProfileCreation;